// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"7be716d5","641":"e77faea3","859":"547dfef6","865":"cdadec84","989":"27b66dd9"}[chunkId] + ".chunk.js";
};